import { presenceState, type Participant } from '@databases/presence';
import { useEffect } from 'react';

export function useBackendAgentEntryPresence(
  entryId: string | undefined,
  participant: Participant | undefined
): void {
  useEffect(() => {
    if (!entryId || !participant) {
      return;
    }

    presenceState.addParticipant({ entryId }, participant);
    return () => presenceState.removeParticipant(participant);
  }, [entryId, participant]);
}
